import React from 'react';
import './style.css';
// import { Link } from 'react-router-dom';
// import { ROUTE_NAMES } from '../../Routes';

export default function PressSection({ presses }) {
  const handleOpenProjectPage = (link) => {
    if (link) {
      window.open(link, '_blank');
    }
  };
  return (
    <>
      <div className='our-press-section'>
        <h2 className='section-title'>Press</h2>
        <div className='press-list'>
          {presses.map((press, index) => (
            <div
              className='press-card'
              key={index}
              onClick={() => handleOpenProjectPage(press.link)}
            >
              <img src={press.image} alt='press-pic' className='press-image' />
              <div className='press-info'>
                <h3 className='press-name'>{press.name}</h3>
                <p className='press-date'>By {press.writenBy}</p>
              </div>
            </div>
          ))}
        </div>
        {/* <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '20px',
          }}
          className='press-btn'
        >
          <Link to={ROUTE_NAMES.PRESS}>
            <button className='bronz-btn'>See more</button>
          </Link>
        </div> */}
      </div>
    </>
  );
}
